export function RoundTo3(num) {
  num = parseFloat(num.toFixed(2));
  return num;
}
